import api from '@/utils/api';
import { NotificationManager } from 'react-notifications';
import {
    FETCH_SERVICE_GROUP_CONFIGURATION,
    FETCH_SERVICE_GROUP_CONFIGURATION_CATALOGS,
} from './types';

const handleError = error => {
    NotificationManager.error(error.response?.data?.msg || 'Không thể xử lý yêu cầu.');
    throw error;
};

const requestWithMessage = (request, successMessage) => request.then(response => {
    NotificationManager.success(successMessage);
    return response.data.data;
}).catch(handleError);

export const fetchServiceGroupConfigurationCatalogs = () => dispatch => (
    api.get('/service-group-configurations/catalogs').then(response => {
        const payload = response.data.data || {};
        dispatch({ type: FETCH_SERVICE_GROUP_CONFIGURATION_CATALOGS, payload });
        return payload;
    }).catch(handleError)
);

export const fetchServiceGroupConfiguration = id => dispatch => (
    api.get(`/service-group-configurations/groups/${id}`).then(response => {
        const payload = response.data.data || { service_group_conditions: [], materials: [] };
        dispatch({ type: FETCH_SERVICE_GROUP_CONFIGURATION, payload });
        return payload;
    }).catch(handleError)
);

export const saveServiceGroupCondition = (id, payload) => () => requestWithMessage(
    id
        ? api.put(`/service-group-configurations/service-group-conditions/${id}`, payload)
        : api.post('/service-group-configurations/service-group-conditions', payload),
    'Đã lưu cấu hình điều kiện.',
);

export const deleteServiceGroupCondition = id => () => requestWithMessage(
    api.delete(`/service-group-configurations/service-group-conditions/${id}`),
    'Đã xóa cấu hình điều kiện.',
);

export const saveServiceCondition = (id, payload) => () => requestWithMessage(
    id
        ? api.put(`/service-group-configurations/service-conditions/${id}`, payload)
        : api.post('/service-group-configurations/service-conditions', payload),
    'Đã lưu điều kiện chuyên môn.',
);

export const deleteServiceCondition = id => () => requestWithMessage(
    api.delete(`/service-group-configurations/service-conditions/${id}`),
    'Đã xóa điều kiện chuyên môn.',
);

export const fetchConditionSources = () => () => (
    api.get('/service-group-configurations/condition-sources')
        .then(response => response.data.data || []).catch(handleError)
);

export const saveConditionSource = (id, payload) => () => requestWithMessage(
    id
        ? api.put(`/service-group-configurations/condition-sources/${id}`, payload)
        : api.post('/service-group-configurations/condition-sources', payload),
    'Đã lưu nguồn tự động của điều kiện.',
);

export const deleteConditionSource = (id, mappingType) => () => requestWithMessage(
    api.delete(`/service-group-configurations/condition-sources/${id}`, { data: { mapping_type: mappingType } }),
    'Đã ngừng sử dụng nguồn tự động.',
);

export const saveServiceGroup = (id, payload) => () => requestWithMessage(
    id
        ? api.put(`/service-group-configurations/service-groups/${id}`, payload)
        : api.post('/service-group-configurations/service-groups', payload),
    'Đã lưu nhóm dịch vụ.',
);

export const deleteServiceGroup = id => () => requestWithMessage(
    api.delete(`/service-group-configurations/service-groups/${id}`),
    'Đã xóa nhóm dịch vụ.',
);

export const saveServiceGroupMaterial = (id, payload) => () => requestWithMessage(
    id
        ? api.put(`/service-group-configurations/materials/${id}`, payload)
        : api.post('/service-group-configurations/materials', payload),
    'Đã lưu cấu hình vật tư.',
);

export const deleteServiceGroupMaterial = id => () => requestWithMessage(
    api.delete(`/service-group-configurations/materials/${id}`),
    'Đã xóa cấu hình vật tư.',
);
